var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonStates, CommonMessages } from '../../localization/helpers.js';
let WorkflowCard = class WorkflowCard extends LitElement {
    handleEditWorkflow() {
        this.dispatchEvent(new CustomEvent('edit-workflow', {
            detail: this.workflow,
            bubbles: true,
            composed: true,
        }));
    }
    handleViewLogs() {
        this.dispatchEvent(new CustomEvent('view-logs', {
            detail: this.workflow,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        return html `
      <basic-card>
        <div class="ggo-workflow-card__header">
          <h2>${this.workflow.name}</h2>
          <basic-status
            class="ggo-workflow-card__status"
            .variant="${this.workflow.is_active ? 'success' : 'danger'}"
            .status="${this.workflow.is_active ? CommonStates.active() : CommonStates.inactive()}"
          ></basic-status>
        </div>
        <p class="ggo-workflow-card__description">
          ${this.workflow.description || CommonMessages.noDescription()}
        </p>
        <div class="ggo-workflow-card__footer">
          <span>${msg('Created by:', { id: 'workflow.card.createdBy', desc: 'Created by label in workflow card' })} ${this.workflow.created_by}</span>
          <div class="ggo-workflow-card__actions">
            <simple-button
              label="${msg('Logs', { id: 'workflow.card.logs', desc: 'View logs button' })}"
              variant="secondary"
              size="medium"
              @button-click=${this.handleViewLogs}
            ></simple-button>
            <simple-button
              label="${msg('Edit', { id: 'workflow.card.editWorkflow', desc: 'Edit workflow button' })}"
              size="medium"
              @button-click=${this.handleEditWorkflow}
            ></simple-button>
          </div>
        </div>
      </basic-card>
    `;
    }
};
WorkflowCard.styles = css `

  .ggo-workflow-card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 7.5px; /* Réduction de 25% */
  }

  .ggo-workflow-card__header h2 {
    margin: 0;
    font-size: 1.125rem; /* Réduction de 25% */
    color: #333;
    font-weight: 700; /* Police en gras pour le titre */
  }

  .ggo-workflow-card__description {
    font-size: 0.75rem; /* Réduction de 25% */
    color: #666;
    margin: 7.5px 0; /* Réduction de 25% */
  }

  .ggo-workflow-card__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.675rem; /* Réduction de 25% */
    color: #999;
  }

  .ggo-workflow-card__actions {
    display: flex;
    gap: 8px;
  }
  `;
__decorate([
    property({ type: Object })
], WorkflowCard.prototype, "workflow", void 0);
WorkflowCard = __decorate([
    localized(),
    customElement('workflow-card')
], WorkflowCard);
export { WorkflowCard };
//# sourceMappingURL=WorkflowCard.js.map